import { useEffect, useState } from "react";
import { fetch } from "../../fetch/graphql";
import * as config from "config-api";
import log from "../../utils/logger/library";

const URL = config.getString("Client.contentApi.baseGraphqlURL");

/*
 * @typedef QueryResult
 * @property {boolean} isLoading
 * @property {Array.<Object>|Object} response
 * @property {Array.<Object>|Object} error
 */

/**
 * Send query with optionally given variables
 * or many queries if many instances of variables
 * @return {QueryResult}
 */
const useQuery = (query, variables) => {
    const [response, setResponse] = useState(undefined);
    const [error, setError] = useState(undefined);
    useEffect(() => {
        let request;
        if (Array.isArray(variables)) {
            request = variables.map((v) => ({
                query,
                variables: v,
            }));
        } else {
            request = {
                query,
                variables,
            };
        }
        fetch(URL, request)
            .then((response) => {
                setResponse(response);
            })
            .catch((error) => {
                log.error("(useQuery)", error);
                setError(error);
            });
    }, []);

    return {
        isLoading: response === undefined && error === undefined,
        response,
        error,
    };
};
export default useQuery;
